import { cn } from '@cannect/lib/utils'
import { Badge } from '@cannect/new-components/atoms/Badge'

/**
 * O hover precisa vir declarado aqui.
 *
 * O átomo `Badge` é usado sem prop `variant`, então cai no `defaultVariants`
 * (`variant: 'default'` = `bg-primary-800 hover:bg-primary-800/90`). O `bg` é
 * sobrescrito por estas classes, mas o `hover:` do variant não — sem um hover
 * próprio, a badge laranja virava verde primary ao passar o mouse, destoando do
 * tom original. Vale para qualquer badge nova aqui: declare o hover junto do bg.
 *
 * O hover **clareia** em vez de escurecer. `orange-200` seria o passo óbvio, mas
 * `orange-700` sobre ele rende 3,91:1 — reprova WCAG AA para os 10px desta badge,
 * que no tom original já está justo (4,59:1). `orange-50` sobe para 4,95:1 e é
 * visivelmente mais suave, que é o efeito pedido. Escala padrão do Tailwind:
 * `orange` não está na paleta do projeto, que só estende as cores próprias.
 */
const PRESCRIPTION_BADGE_CLASS = 'bg-orange-100 text-orange-700 hover:bg-orange-50'

export const PRESCRIPTION_BADGE_MAP: Record<string, { label: string; className: string }> = {
  prescription: { label: 'Receita obrigatória', className: PRESCRIPTION_BADGE_CLASS },
  prescription_highlight: { label: 'Receita obrigatória', className: PRESCRIPTION_BADGE_CLASS },
  prescription_restricted: { label: 'Receita obrigatória', className: PRESCRIPTION_BADGE_CLASS },
  prescription_blue: { label: 'Receita obrigatória', className: PRESCRIPTION_BADGE_CLASS },
  prescription_yellow: { label: 'Receita obrigatória', className: PRESCRIPTION_BADGE_CLASS },
  // Mesmo defeito: sem hover proprio, a badge azul tambem virava verde.
  // Aqui o texto e branco, entao clarear demais quebra o contraste
  // (`information-300` daria 3,68:1). O `/90` da convencao do atomo mantem 6,44:1.
  refrigerated: {
    label: 'Refrigerado',
    className: 'bg-information-700 text-white hover:bg-information-700/90'
  }
}

const DETAILS_ONLY_CODES = ['refrigerated']

export type TPrescriptionBadgesProps = {
  codes?: string[] | null
  className?: string
  showDetailsOnlyBadges?: boolean
}

export const PrescriptionBadges = ({ codes, className, showDetailsOnlyBadges = false }: TPrescriptionBadgesProps) => {
  const visibleCodes = showDetailsOnlyBadges ? codes : codes?.filter((code) => !DETAILS_ONLY_CODES.includes(code))

  if (!visibleCodes?.length) return null

  return (
    <div className={cn('flex flex-wrap items-center gap-1', className)}>
      {visibleCodes.map((code) => {
        const badge = PRESCRIPTION_BADGE_MAP[code]
        if (!badge) return null
        return (
          <Badge key={code} size="xs" rounded="lg" className={badge.className}>
            {badge.label}
          </Badge>
        )
      })}
    </div>
  )
}
